import React from "react";
import {
  TaskCardContainer,
  TaskHeader,
  TaskTitleSection,
  AccentLine,
  TitleContent,
  TaskTitle,
  TaskDescription,
  TaskMiddle,
  RouteInfo,
  RouteLabel,
  RouteCount,
  CountNumber,
  CountUnit,
  ActionButtons,
  Button,
  TaskFooter,
  Separator,
  TaskDate,
  DeleteButton,
} from "../styled/shared/TaskCard.styles";
import { deleteTask } from "../../api/ProjectAPI";
import { useCustomAlertStore, useProjectMEditStore } from "../../Store/store";
import DotMenuButton from "../common/DotMenuButton";
import { useParams } from "react-router-dom";

// 태스크 이름, 생성된 경로 개수, 최근 갱신일
export default function TaskCard({
  index,
  taskName = "전주시 1번 논밭",
  taskDescription = "전주시 1번 논밭입니다.",
  routeCount = 0,
  date = "2025.08.08",
  onMapRendering,
  onRouteGeneration,
  fileId,
  fetchTaskList,
  accessType,
  projectId,
  setReload,
  currentAccessType,
}) {
  const { showWarningAlert, showSuccessAlert } = useCustomAlertStore();
  date = date.split(" ")[0].split("-").join(".");
  const { setIsProjectMEditOpen, setProjectData } = useProjectMEditStore();

  const onDelete = (index) => {
    const fetchDeleteTask = async () => {
      const response = await deleteTask(index);
      if (response.success) {
        fetchTaskList(currentAccessType);
        showSuccessAlert("프로젝트 삭제 성공");
      }
    };

    showWarningAlert(
      "프로젝트 삭제",
      "지워진 프로젝트는 복구할 수 없습니다.",
      fetchDeleteTask,
    );
  };

  const onEdit = (index) => {
    setIsProjectMEditOpen(true);
    setProjectData({
      fileId: fileId,
      accessType: accessType,
      projectId: projectId,
    });
  };

  const handleEditClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onEdit(index);
  };

  const handleDeleteClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onDelete(index);
  };

  return (
    <TaskCardContainer>
      {/* 상단 섹션 */}
      <TaskHeader>
        <TaskTitleSection>
          <AccentLine />
          <TitleContent>
            <TaskTitle>{taskName}</TaskTitle>
            <TaskDescription>{taskDescription}</TaskDescription>
          </TitleContent>
        </TaskTitleSection>
      </TaskHeader>

      {/* 중간 섹션 */}
      <TaskMiddle>
        <RouteInfo>
          <RouteLabel>경로</RouteLabel>
          <RouteCount>
            <CountNumber>{String(routeCount).padStart(2, "0")}</CountNumber>
            <CountUnit>개</CountUnit>
          </RouteCount>
        </RouteInfo>

        <ActionButtons>
          <Button
            className="btn-outline"
            onClick={() => onMapRendering(fileId)}
          >
            지도 뷰어
          </Button>
          <Button
            className="btn-filled"
            onClick={() => onRouteGeneration(fileId, index)}
          >
            경로 생성
          </Button>
        </ActionButtons>
      </TaskMiddle>

      {/* 하단 섹션 */}
      <TaskFooter>
        <Separator />
        <TaskDate>{date}</TaskDate>
      </TaskFooter>

      <DotMenuButton
        handleEditClick={handleEditClick}
        handleDeleteClick={handleDeleteClick}
      />
    </TaskCardContainer>
  );
}
